import {
  IDefaultEmailTemplate,
  TypeEmailTemplates,
} from "@evennt-tech/api-v2-core";
import { useDefaultEmailTemplates } from "store/email-templates";
import { shallow } from "zustand/shallow";
import { useEffect } from "react";

type UseDefaultEmailTemplateArgs = {
  type: TypeEmailTemplates;
};

export type UserDefaultEmailTemplateRes = {
  defaultEmailTemplate: IDefaultEmailTemplate | null;
  isLoading: boolean;
};

function useDefaultEmailTemplate({
  type,
}: UseDefaultEmailTemplateArgs): UserDefaultEmailTemplateRes {
  const { fetch: fetchDefaultEmailTemplates } = useDefaultEmailTemplates();

  const defaultEmailTemplate = useDefaultEmailTemplates((state) =>
    state.getByType(type)
  );

  const isLoading = useDefaultEmailTemplates(
    (state) => state.isLoading,
    shallow
  );

  useEffect(() => {
    const load = async () => {
      await fetchDefaultEmailTemplates();
    };

    load();
  }, []);

  return {
    defaultEmailTemplate,
    isLoading,
  };
}

export default useDefaultEmailTemplate;
